import classNames from 'classnames'
import * as React from 'react'
import {render} from 'storyblok-rich-text-react-renderer'

import {unwrapAllNodeResolvers} from '@/common/utils'
import Image from '@/components/Image'

const Testimonial = ({quote, author, job, picture, logo, theme, className}) => {
  return (
    <figure
      className={classNames(
        'space-y-4 rounded-2xl p-6 md:shadow-[0px_18px_22px_rgba(227,243,32,0.13)]',
        {'bg-turquoise-400': theme === 'blue', 'bg-yellow-400': theme !== 'blue'},
        className
      )}
    >
      <div className='flex items-center gap-3'>
        <div className='h-10 w-10 flex-none'>
          <div className='aspect-h-1 aspect-w-1'>
            <Image
              {...picture}
              ratio='1:1'
              sizes={{sm: '40', unit: 'px'}}
              className='rounded-full'
              alt=''
            />
          </div>
        </div>

        <figcaption className='flex-1'>
          {author ? <span className='body-m-medium'>{author}</span> : null}
          {author && job ? <span> - </span> : null}
          {job ? <span className='body-m-bold'>{job}</span> : null}
        </figcaption>

        <QuoteSymbol aria-hidden className='flex-none' />
      </div>

      <blockquote className='body-m-italic'>
        “ {render(quote, {nodeResolvers: unwrapAllNodeResolvers})} ”
      </blockquote>

      {logo && logo.filename && (
        <div className='w-32'>
          <div className='aspect-h-9 aspect-w-16'>
            <Image
              {...logo}
              alt=''
              ratio='16:9'
              fitIn
              className='object-left'
              sizes={{sm: '128', unit: 'px'}}
            />
          </div>
        </div>
      )}
    </figure>
  )
}

const QuoteSymbol = (props) => (
  <svg
    width='45'
    height='32'
    viewBox='0 0 45 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_439_4833)'>
      <path
        d='M17.8264 5.94649C16.8995 3.65843 15.212 1.65432 12.9288 0.658991C10.5164 -0.394623 7.80685 -0.168957 5.57715 1.24035C4.53731 1.89792 3.64009 2.76174 2.94637 3.76305C0.115044 6.07651 -0.595018 10.2297 0.891947 13.7522C1.80255 15.9088 3.45588 17.6737 5.63657 18.5435C7.9242 19.4552 10.4807 19.1892 12.6926 18.1998C13.6968 17.7515 14.6401 17.1193 15.4645 16.3571C14.7886 20.712 12.1504 24.8862 8.48572 27.225C6.86654 28.2592 5.0097 28.9646 3.15433 29.1514C2.39377 29.2276 1.74016 29.7507 1.74016 30.5742C1.74016 31.2841 2.38931 32.0746 3.15433 31.9969C11.7018 31.1361 18.1993 23.0823 18.4414 14.6235C18.4696 13.6431 18.3983 12.6747 18.2409 11.7212C18.7103 9.81573 18.5736 7.79816 17.8249 5.94799L17.8264 5.94649ZM7.07154 5.85533C7.08194 5.84487 7.09531 5.82992 7.11462 5.809C7.21415 5.69841 7.31813 5.5938 7.42657 5.49217C7.43697 5.4832 7.43697 5.4832 7.44291 5.47573C7.49639 5.43687 7.55284 5.39802 7.60928 5.36364C7.67316 5.32628 7.93163 5.19626 7.93015 5.19028C8.53176 4.95266 8.99226 4.95565 9.53743 5.10809C10.0767 5.25753 10.6397 5.59828 11.0764 6.01375C12.088 6.9747 12.6406 8.21363 12.6109 9.51384C12.5916 10.3537 12.0256 11.1772 11.3512 11.6689C11.3824 11.4671 11.4047 11.2639 11.4091 11.0576C11.4374 9.80377 10.9694 8.57829 10.2014 7.60538C9.50327 6.72064 8.49314 6.04812 7.37012 5.88223C7.26911 5.86729 7.16958 5.86131 7.06857 5.85981C7.07006 5.85682 7.07005 5.85533 7.07154 5.85234V5.85533ZM11.1759 15.7713C8.19605 16.934 5.22361 15.9028 3.73961 13.1664C3.88519 13.2964 4.02779 13.4294 4.18526 13.549C7.56323 16.118 13.3388 15.6995 15.0634 11.3595C15.1228 11.2086 15.1659 11.0547 15.2105 10.9007C15.2654 11.104 15.3145 11.3087 15.359 11.515C14.6876 13.4234 13.1189 15.0121 11.1759 15.7713Z'
        fill='#7F6AFF'
        stroke='#FDFFE8'
        strokeWidth='0.355557'
      />
      <path
        d='M43.5334 5.9467C42.6065 3.65864 40.919 1.65453 38.6358 0.659197C36.2234 -0.394417 33.5139 -0.168751 31.2842 1.24055C30.2443 1.89813 29.3471 2.76194 28.6534 3.76325C25.8221 6.07672 25.112 10.2299 26.599 13.7524C27.5096 15.909 29.1629 17.674 31.3436 18.5437C33.6312 19.4554 36.1877 19.1894 38.3996 18.2C39.4038 17.7517 40.3471 17.1195 41.1715 16.3573C40.4956 20.7123 37.8574 24.8864 34.1927 27.2252C32.5736 28.2594 30.7167 28.9648 28.8614 29.1516C28.1008 29.2278 27.4472 29.7509 27.4472 30.5744C27.4472 31.2843 28.0963 32.0748 28.8614 31.9971C37.4103 31.1348 43.9078 23.0795 44.1484 14.6207C44.1766 13.6403 44.1053 12.6719 43.9479 11.7184C44.4173 9.81294 44.2806 7.79538 43.532 5.94521L43.5334 5.9467ZM32.7786 5.85554C32.789 5.84507 32.8023 5.83013 32.8216 5.80921C32.9212 5.69861 33.0252 5.594 33.1336 5.49238C33.144 5.48341 33.144 5.48341 33.1499 5.47594C33.2034 5.43708 33.2599 5.39822 33.3163 5.36385C33.3802 5.32649 33.6387 5.19647 33.6372 5.19049C34.2388 4.95287 34.6993 4.95585 35.2445 5.10829C35.7837 5.25774 36.3467 5.59848 36.7834 6.01395C37.795 6.97491 38.3476 8.21384 38.3179 9.51404C38.2986 10.3539 37.7326 11.1774 37.0582 11.6691C37.0894 11.4673 37.1117 11.2641 37.1162 11.0579C37.1444 9.80397 36.6765 8.5785 35.9085 7.60558C35.2103 6.72085 34.2002 6.04833 33.0772 5.88244C32.9761 5.86749 32.8766 5.86151 32.7756 5.86002C32.7771 5.85703 32.7771 5.85554 32.7786 5.85255V5.85554ZM36.8829 15.7715C33.9031 16.9342 30.9306 15.903 29.4466 13.1666C29.5922 13.2966 29.7348 13.4296 29.8923 13.5492C33.2703 16.1182 39.0458 15.6997 40.7704 11.3597C40.8299 11.2088 40.8729 11.0549 40.9175 10.9009C40.9725 11.1042 41.0215 11.3089 41.0661 11.5152C40.3946 13.4236 38.826 15.0123 36.8829 15.7715Z'
        fill='#7F6AFF'
        stroke='#FDFFE8'
        strokeWidth='0.355557'
      />
    </g>
    <defs>
      <clipPath id='clip0_439_4833'>
        <rect width='44.089' height='32' fill='white' transform='matrix(-1 0 0 -1 44.2222 32)' />
      </clipPath>
    </defs>
  </svg>
)

export default Testimonial
